import React from 'react';
const ActivityMediumBox = (props) => (
  // <div className="px-6 py-3 bg-white rounded shadow h-288">
  <div className='h-auto px-6 py-3 overflow-auto bg-white rounded shadow max-h-460px'>
    <div className='text-xl not-italic font-medium uppercase text-summary-header '>{props.header}</div>
    {props.children}
  </div>
);
export default ActivityMediumBox;
